document.addEventListener('DOMContentLoaded', () => {
	const header = document.querySelector('[data-header]');
	if (!header) return;
	const headerInner = header.querySelector('[data-header-inner]') || header;
	const logo = header.querySelector('[data-animate-logo]');
	if (!logo) return;

	const originalHeight = logo.offsetHeight;
	let scrolledHeight = 60;
	if (window.innerWidth < 1024) {
		scrolledHeight = 48;
	}
	let lastState = null;

	function onScroll() {
		const isScrolled = window.scrollY > 20;
		if (isScrolled && lastState !== true) {
			header.classList.remove('shadow-transparent');
			headerInner.classList.remove('lg:pt-12');
			logo.style.height = scrolledHeight + 'px';
			lastState = true;
		} else if (!isScrolled && lastState !== false) {
			header.classList.add('shadow-transparent');
			headerInner.classList.add('lg:pt-12');
			logo.style.height = originalHeight + 'px';
			lastState = false;
		}
	}

	// Set initial height style
	logo.style.height = originalHeight + 'px';

	window.addEventListener(
		'scroll',
		() => {
			window.requestAnimationFrame(onScroll);
		},
		{ passive: true }
	);
});
